module.exports = {
  "/": {
    "success": {
      "not found page loaded": [
        "NOT_FOUND_LOAD"
      ]
    }
  },
  "/*": {
    "success": {
      "deal plan page loaded": [
        "DEAL_PLAN_LOAD"
      ],
      "not found page loaded": [
        "NOT_FOUND_LOAD"
      ]
    },
    "error": [
      "DEAL_PLAN_NOT_FOUND_LOAD"
    ]
  }
};